// Trimmed from LC2 (src/app/store/reducers/loading.js) to just the `tokenVerification`
// slice used by the auth flow. residents/campaigns/communities matchers come back once
// coreApi/actionsApi are ported — see TODO markers.
import {createSlice} from '@reduxjs/toolkit';
import {sessionApi} from '../../../features/loyaltyCloudApi/session';
// TODO(port coreApi/actionsApi):
// import {residentsApi} from '../../../features/coreApi/residentsSlice';
// import {campaignsSlice} from '../../../features/actionsApi/campaignsSlice';
// import {communitiesApi} from '../../../features/coreApi/communitiesSlice';

const initialState = {
    tokenVerification: {
        isLoading: false,
        isSuccess: false,
        isError: false
    }
};

const loadingSlice = createSlice({
    name: 'alerts',
    initialState,
    reducers: {
        resetLoadingState: () => {
            return initialState;
        },

        resetElementLoadingState: (state, {payload}) => {
            state[payload].isLoading = false;
            state[payload].isSuccess = false;
            state[payload].isError = false;
        }
    },
    extraReducers(builder) {
        builder
            .addMatcher(sessionApi.endpoints.getSessionInfo.matchPending, (state) => {
                state.tokenVerification.isLoading = true;
                state.tokenVerification.isError = false;
                state.tokenVerification.isSuccess = false;
            })
            .addMatcher(sessionApi.endpoints.getSessionInfo.matchFulfilled, (state) => {
                state.tokenVerification.isSuccess = true;
                state.tokenVerification.isLoading = false;
                state.tokenVerification.isError = false;
            })
            .addMatcher(sessionApi.endpoints.getSessionInfo.matchRejected, (state) => {
                state.tokenVerification.isError = true;
                state.tokenVerification.isLoading = false;
                state.tokenVerification.isSuccess = false;
            })
            .addMatcher(sessionApi.endpoints.getSsoSessionInfo.matchPending, (state) => {
                state.tokenVerification.isLoading = true;
                state.tokenVerification.isError = false;
                state.tokenVerification.isSuccess = false;
            })
            .addMatcher(sessionApi.endpoints.getSsoSessionInfo.matchFulfilled, (state) => {
                state.tokenVerification.isSuccess = true;
                state.tokenVerification.isLoading = false;
                state.tokenVerification.isError = false;
            })
            .addMatcher(sessionApi.endpoints.getSsoSessionInfo.matchRejected, (state) => {
                state.tokenVerification.isError = true;
                state.tokenVerification.isLoading = false;
                state.tokenVerification.isSuccess = false;
            });
    }
});

export const {resetLoadingState, resetElementLoadingState} = loadingSlice.actions;
export default loadingSlice.reducer;

export const getTokenVerificationLoadingStatus = (state) => state.loading.tokenVerification;
